// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lottie[data-v-5d3083bc] {\n  width: 20rem;\n}\n.lottie__container[data-v-5d3083bc] {\n  position: fixed;\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100vh;\n  flex-direction: column;\n  background-color: #eeeeee;\n}\n.lottie__label[data-v-5d3083bc] {\n  font-weight: 400;\n  font-style: italic;\n}\n", ""]);
// Exports
module.exports = exports;
